import './index.css'
import { Suspense, useEffect, useState } from 'react'
import PostLogin from 'shared/api/endpoints/authorization/Post_Login'
import NotificationFeature from 'features/notification'
import ReactLoading from 'react-loading'
import { Button, Input, ToggleTheme } from '@office/ui-kit'
import useNotification from 'shared/hooks/useNotification'
import { NotificationTypeEnum } from 'shared/types'
import { useDispatch, useSelector } from 'react-redux'
import { ThemeState, Theme_Actions } from 'shared/stores'

type ErrorType = null | string

function App() {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<ErrorType>(null)
  const { html_notification } = useNotification()
  const dispatch = useDispatch()
  const theme = useSelector((state: ThemeState) => state.theme.THEME)
  const themes = useSelector((state: ThemeState) => state.theme.THEMES)
  const useQuery = () => new URLSearchParams(window.location.search)
  const referrer = useQuery().get('referrer')

  function authHandler() {
    if (login.trim() === '' || password.trim() === '') {
      return setError('Одно из полей пустое')
    }

    PostLogin({
      login: login,
      password: password,
    })
      .then((res) => {
        if (res.status === 200 && referrer) {
          return (window.location.href =
            `${referrer}?token=${res.data.token}&refresh=${res.data.refresh}` || '')
        } else if (res.status === 200 && !referrer) {
          setError('Ошибка перенаправления')
        } else {
          setError('Неправильный логин или пароль')
        }
      })
      .catch((err) => {
        if (err.code === 'ERR_NETWORK') {
          return setError('Ошибка соединения с сервером')
        }

        return setError('Ошибка сервера')
      })
  }

  function keyHandler(e: any) {
    if (e.key === 'Enter') {
      authHandler()
    } else if (error !== null) {
      setError(null)
    }
  }

  function toggleTheme() {
    if (localStorage.getItem('theme') === 'default') {
      return dispatch({
        type: Theme_Actions.CHANGE_THEME,
        payload: 'dark',
      })
    } else {
      return dispatch({
        type: Theme_Actions.CHANGE_THEME,
        payload: 'default',
      })
    }
  }

  useEffect(() => {
    if (error) {
      return html_notification({
        title: error,
        text: error,
        timeout: 10,
        type: NotificationTypeEnum.error,
      })
    }
    // eslint-disable-next-line
  }, [error])

  useEffect(() => {
    if (window.location.search) {
      const URLArguments = JSON.parse(
        '{"' +
          decodeURI(
            window.location.search.slice(1).replace(/&/g, '","').replace(/=/g, '":"'),
          ) +
          '"}',
      )
      if (themes.includes(URLArguments.theme)) {
        dispatch({
          type: Theme_Actions.CHANGE_THEME,
          payload: URLArguments.theme,
        })
        return localStorage.setItem('theme', URLArguments.theme)
      }
    }

    if (themes.includes(localStorage.getItem('theme'))) {
      dispatch({
        type: Theme_Actions.CHANGE_THEME,
        payload: localStorage.getItem('theme'),
      })
    } else {
      dispatch({
        type: Theme_Actions.CHANGE_THEME,
        payload: 'dark',
      })
    }
  }, [dispatch, themes, referrer])

  return (
    <Suspense fallback={<ReactLoading color="#0042ED" type="spin" />}>
      <div className="page" data-theme={theme} onKeyDown={(e) => keyHandler(e)}>
        <form className="login-form">
          <div className="login-form__container">
            <div className="login-form-logo">
              <img src={require('./logo.png')} alt="" />
            </div>
            <div className="login-form-nickname">
              <div className="login-form-nickname__input">
                <Input
                  setValue={setLogin}
                  value={login}
                  placeholder="Логин"
                  form="default"
                  error={error}
                  tab={1}
                />
              </div>
            </div>

            <div className="login-form-password">
              <div className="login-form-password__input">
                <Input
                  setValue={setPassword}
                  value={password}
                  placeholder="Пароль"
                  type="password"
                  error={error}
                  tab={2}
                />
              </div>
            </div>

            <div className="login-button">
              <Button
                form="ellipse"
                tab={3}
                title="Войти"
                handler={() => {
                  authHandler()
                }}
              ></Button>
            </div>
          </div>
        </form>

        <div className="switch-theme">
          <div className="switch-theme__text">
            <p>Сменить тему</p>
          </div>
          <div className="switch-theme__toggle">
            <ToggleTheme
              toggle_action={toggleTheme}
              toggle_state={localStorage.getItem('theme') === 'dark' ? true : false}
            />
          </div>
        </div>

        <NotificationFeature />
      </div>
    </Suspense>
  )
}

export default App
